import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { LogIn } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user?.is_admin) navigate("/admin", { replace: true });
  }, [user, loading, navigate]);

  const signIn = () => {
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center bg-[var(--layor-ivory)] px-6">
      <div className="w-full max-w-md bg-white border border-[var(--layor-border)] rounded-3xl p-10 shadow-[0_30px_80px_-30px_rgba(10,25,47,0.25)]">
        <div className="eyebrow text-[var(--layor-blue)]">Admin</div>
        <h1 className="mt-2 font-display-black text-3xl text-[var(--layor-navy)] leading-tight">Sign in to the Slide Deck Builder</h1>
        <p className="mt-4 text-sm text-[var(--layor-muted)] leading-relaxed">
          Only allow-listed admin emails may access this area. If your Google email is not on the list, you will be redirected to the site home.
        </p>
        <button onClick={signIn} className="btn-primary mt-8 inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-semibold w-full justify-center" data-testid="google-signin">
          <LogIn size={16} /> Sign in with Google
        </button>
        <Link to="/" className="mt-6 block text-center text-sm text-[var(--layor-muted)] hover:text-[var(--layor-navy)]">← Back to site</Link>
      </div>
    </div>
  );
}
